import Model from '@/models/Model'

export default class AConfirm extends Model {
    resource() {
        return 'confirm'
    }
}